import AuthService from '../auth'
import { createAxiosClient } from '../core'

const client = createAxiosClient('/api/empresas')

export default AuthService.register(client)
